import { PagedSingleSelectField, laravelServiceSelectFetchConfig, roleService } from "@dgs/core";
import { FC } from "react";

const fetchConfig = laravelServiceSelectFetchConfig(roleService);

interface Props {
	name: string;
	label: string;
	description?: string;
	required?: boolean;
	clearable?: boolean;
	disabled?: boolean;
}

export const RoleSingleSelect: FC<Props> = (props) => {
	return <PagedSingleSelectField {...props} fetchConfig={fetchConfig} />;
};
